import { z } from 'zod';
import { dateRangeQuerySchema } from './common';

export const getCategoryUpdatesQuerySchema = dateRangeQuerySchema;

export const categoryUpdateRowSchema = z.object({
  businessAccountId: z.string(),
  templateId: z.string(),
  templateName: z.string(),
  language: z.string(),
  previousCategory: z.string().nullable(),
  newCategory: z.string(),
  createdAt: z.union([z.string(), z.date()]),
  businessId: z.number(),
  businessName: z.string(),
  bizWhatsappNumber: z.string().nullable(),
  countryCode: z.number().nullable(),
});

export const getCategoryUpdatesResponseSchema = z.array(
  categoryUpdateRowSchema,
);

export type GetCategoryUpdatesQuery = z.infer<
  typeof getCategoryUpdatesQuerySchema
>;
export type CategoryUpdateRow = z.infer<typeof categoryUpdateRowSchema>;
